import * as React from "react";
import Box from "@mui/material/Box";
//import ParentBox from '../components/ParentBox';
import SidebarMenu from "./SidebarMenu";
import "../css/reset.css";
import "../css/layout.css";
import "../css/common.css";
import "../css/style.css";
import "../css/dashboard.css";
import "../css/lnb.css";
import { WeatherPaper } from "pages/components/WeatherPaper";
import {
  SwItsAvgSpeedTotalProvider,
  SwItsAvgSpeedTotalInfo,
  SwItsAvgSpeedTotalChart,
} from "pages/components/dashboard/SwItsGetAvgSpeed";
import {
  SwItsTrafficTotalProvider,
  SwItsTrafficTotalInfo,
  SwItsTrafficTotalChart,
} from "pages/components/dashboard/SwitsTrafficTotalData";
import {
  SwItsCrsrdControlDelay,
  SwItsCrsrdControlDelayTotalInfo,
  SwItsCrsrdControlDelayTotalChart,
} from "pages/components/dashboard/SwitsCrsrdControlDelay";
//import { SwItsSignalSkipTotalProvider, SwItsSignalSkipTotalInfo } from 'pages/components/dashboard/SwItsGetSnstv';
import {
  SwItsSnstvSignalProvider,
  SwItsIncreaseGreenSignalTotalInfo,
  SwItsSnstvSignalTotalInfo,
} from "pages/components/dashboard/SwItsGetSnstvSignal";
import {
  SwItsEmergVehTotalProvider,
  SwItsEmergVehTotalInfo,
} from "pages/components/dashboard/SwItsGetEmergVeh";
import {
  SwItsEvntTotalProvider,
  SwItsEvntTotalInfo,
} from "pages/components/dashboard/SwItsGetEvnt";
import {
  SwItsBisCntTotalProvider,
  SwItsBisCntTotalInfo,
} from "pages/components/dashboard/SwItsGetBisCnt";
import {
  SwItsBisPssngrDataProvider,
  SwItsBisPssngrTotalInfoDash,
} from "pages/components/dashboard/SwItsGetBusPssngrData";
import {
  SwItsAutoDriveProvider,
  SwItsAutoDriveDataInfo,
} from "pages/components/dashboard/SwItsGetAutoDriveCnt";


import { useTranslation } from 'react-i18next';

export default function IntegratedControlViewD() {
  React.useEffect(() => { }, []);
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'ko' ? 'en' : 'ko';
    i18n.changeLanguage(newLang);
  };

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      <div className="dashboard container flx a_center">
        <SidebarMenu />
        <div className="ctrlMain">
          <div className="mainTit flx j_spc_btw a_center">
            {/* <div className="titBox">
              <p className="subTit">수원시 ITS</p>
              <p className="tit">오늘의 교통 현황</p>
            </div> */}
            <div className="titBox">
              <p
                className={`subTit${i18n.language === 'en' ? '_en' : ''}`}
                onClick={toggleLanguage}
                style={{ cursor: 'pointer', userSelect: 'none' }}
              >
                {t('subtitle')}
              </p>
              <p className={`tit${i18n.language === 'en' ? '_en' : ''}`}>
                {t('mainTitle1')}
              </p>
            </div>
            <div className="weatherWrap flx a_center j_spc_btw">
              <WeatherPaper /> {/* sx는 필요에 맞게 조정 */}
            </div>
          </div>
          <div className="mainInfo L_tb gap60">
            {/*메인박스*/}
            <div className="L_d L_lr">
              <SwItsAvgSpeedTotalProvider>
                <div className="inner L_3m flx flx_col j_spc_btw">
                  <div className="titWrap flx j_center">
                    <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-03)' }}>{t('avgSpeed')}</h2>
                    {/* <h2 className="boxTit" style={{ color: 'var(--iv-03)' }}>평균 통행속도</h2> */}
                  </div>
                  <div className="trfFlow flx j_center a_center">
                    <SwItsAvgSpeedTotalInfo />
                  </div>
                  <div className="chartWrap">
                    {/*<p className='chartTit'></p>*/}
                    <div className="chartBox">
                      <SwItsAvgSpeedTotalChart />
                    </div>
                  </div>
                </div>
              </SwItsAvgSpeedTotalProvider>
              <SwItsTrafficTotalProvider>
                <div className="inner L_3m flx flx_col j_spc_btw">
                  <div className="titWrap flx  j_center">
                   <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`}  style={{ color: 'var(--iv-03)' }}>{t('TrafficVolume')}</h2>
                  </div>
                  <div className="trfFlow flx j_center a_center">
                    <div className="traffic-info flx flx_col a_center j_center">
                      <SwItsTrafficTotalInfo />
                    </div>
                  </div>
                  <div className="chartWrap">
                    <div className="chartBox">
                      <SwItsTrafficTotalChart />
                    </div>
                  </div>
                </div>
              </SwItsTrafficTotalProvider>
              <SwItsCrsrdControlDelay>
                <div className="inner L_3m flx flx_col j_spc_btw">
                  <div className="titWrap flx  j_center">
                    {/* <h2 className="boxTit" style={{ color: 'var(--iv-03)' }}>교차로 평균지체</h2> */}
                    <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-03)', letterSpacing: '-5px' }}>{t('AverageControlDelay')}</h2>
                  </div>
                  <div className="trfFlow flx j_center a_center">
                    <SwItsCrsrdControlDelayTotalInfo />
                  </div>
                  <div className="chartWrap">
                    <div className="chartBox">
                      <SwItsCrsrdControlDelayTotalChart />
                    </div>
                  </div>
                </div>
              </SwItsCrsrdControlDelay>
            </div>
            <div className="L_d L_tb">
              <div className="L_d L_lmr">
                <div className="inner L_3m">
                  <div className="titWrap flx  j_center">
                     <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-04)' }}>{t('GreenTimeIncreaseRate')}</h2>
                  </div>
                  <div className="flx flx_col a_center">
                    <SwItsSnstvSignalProvider>
                      {/* <SwItsSnstvSignalTotalInfo/> */}
                      <SwItsIncreaseGreenSignalTotalInfo showTitle={false} />
                    </SwItsSnstvSignalProvider>
                  </div>
                </div>
                <div className="inner L_3m">
                  <div className="titWrap flx j_center">
                    <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`}style={{ color: 'var(--iv-04)' }}>{t('EmergencyVehicle')}</h2>
                  </div>
                  <div className="flx flx_col a_center">
                    <SwItsEmergVehTotalProvider>
                      <SwItsEmergVehTotalInfo />
                    </SwItsEmergVehTotalProvider>
                  </div>
                </div>
                <div className="inner L_3m">
                  <div className="titWrap flx j_center">
                    <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-04)' }}>{t('IncidentsHazards')}</h2>
                  </div>
                  <SwItsEvntTotalProvider>
                    <SwItsEvntTotalInfo />
                  </SwItsEvntTotalProvider>
                </div>
              </div>
              <div className="L_d L_lmr">
                <div className="inner L_3m flx flx_col a_center j_center">
                  <div className="titWrap flx j_center">
                    <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-05)' }}>{t('BusOperation')}</h2>
                  </div>
                  <SwItsBisCntTotalProvider>
                    <SwItsBisCntTotalInfo />
                  </SwItsBisCntTotalProvider>
                </div>
                <SwItsBisPssngrDataProvider>
                  <SwItsBisPssngrTotalInfoDash />
                </SwItsBisPssngrDataProvider>
                <div className="inner L_3m flx flx_col a_center j_center">
                  <div className="titWrap flx j_center">
                  <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-05)' }}>{t('AutonomousVehicle')}</h2>
                  </div>
                  <SwItsAutoDriveProvider>
                    <SwItsAutoDriveDataInfo />
                  </SwItsAutoDriveProvider>
                  {/* <div className="flx flx_col a_center">
                    <div className="flx a_flx_end">
                      <span className="subTxt" style={{ marginRight: "10px" }}>
                        운행중
                      </span>
                      <span className="nbr">0</span>
                      <span className="subTxt" style={{ marginLeft: "10px" }}>
                        대
                      </span>
                      <span className="subTxt sls">
                        |
                      </span>
                      <span className="subTxt" style={{ marginRight: "20px" }}>
                        총
                      </span>
                      <span className="nbr">5</span>
                      <span className="subTxt" style={{ marginLeft: "20px" }}>
                        대
                      </span>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
}
